import { render, staticRenderFns } from "./case-sessions-tab.vue?vue&type=template&id=a94ec40c&scoped=true&"
import script from "./case-sessions-tab.vue?vue&type=script&lang=js&"
export * from "./case-sessions-tab.vue?vue&type=script&lang=js&"
import style0 from "./case-sessions-tab.vue?vue&type=style&index=0&id=a94ec40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94ec40c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VProgressLinear,VRow})
